import { green, red } from '@material-ui/core/colors'

const LoginSSOStyles = {
  container: {
    padding: 23 + 16,
  },
  textField: {
    marginLeft: 23 + 8,
    marginRight: 23 + 8,
    width: '90%',
  },
  buttonContainer: {
    display: 'grid',
    gridAutoFlow: 'column',
    justifyContent: 'center',
    gridGap: 15,
  },
  button: {
    width: '100%',
  },
  successText: {
    padding: 23,
    backgroundColor: green[200],
    borderColor: green[400],
    borderWidth: 1,
    borderStyle: 'solid',
  },
  errorText: {
    padding: 23,
    backgroundColor: red[200],
    borderColor: red[400],
    borderWidth: 1,
    borderStyle: 'solid',
  },
  tertiaryButton: {
    borderColor: '#8C8C8C',
    color: '#8C8C8C',
    backgroundColor: 'transparent',
    fontSize: '11px',
    lineHeight: '15px',
    letterSpacing: '.7px',
    fontWeight: 500,
    borderRadius: 30,
    minHeight: 36,
    boxShadow: 'none',
  },
  leftIcon: {
    width: '100%',
    maxWidth: 130,
    height: 'auto',
  },
  buffering: {
    animation: 'rotate 1.5s infinite linear',
  },
  noAccount: {
    padding: 8,
  },
}

export default LoginSSOStyles
